import React from "react";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import "./assets/css/bootstrap.min.css";
import "./assets/css/main.css";
import Home from "./views/Home";
import Login from "./views/Login";
import Profile from "./views/Profile";
import ChiefComplain from "./views/CheifComplain";
import Questions from "./views/Questions";
import Thankyou from "./views/Thankyou";
import PatientNarrative from "./views/PatientNarrative";
import CheifComplainLocation from "./views/CheifComplainLocation";
import PendingPatients from "./views/surgeon/PendingPatients";
import SurgeonLogin from "./views/surgeon/SurgeonLogin";
import Master from "./views/Master";

function App() {
  return (
    <Router>
      <React.Fragment>
        <Switch>
          {/* <PrivateRoute exact path="/" component={Home} /> */}
          {/* <Route path="/home" component={Home} /> */}
          {/* <Route component={Home} /> */}
          <Route path="/" exact component={Master} />
          <Route path="/login" component={SurgeonLogin} />
          <Route path="/thankyou" component={Thankyou} />
          <Route path="/surgeon/login" component={SurgeonLogin} />
          <Route path="/master" component={Master} />

        </Switch>
      </React.Fragment>
    </Router>
  );
}

export default App;
